import getGPAColor from "./getGPAColor";

let width, height, gradient;
export function getGradient(chart, chartArea) {
  const { ctx, scales } = chart;      // ⬅️ get ctx & scales from chart
  const { top, bottom } = chartArea;
  const y = scales.y;                 // ⬅️ chart.scales.y (not ctx.scales)

  const min = y.min;
  const max = y.max;
  const pos = (v) => (v - min) / (max - min);

  const chartWidth  = chartArea.right - chartArea.left;
  const chartHeight = bottom - top;
  if (!gradient || width !== chartWidth || height !== chartHeight) {
    width = chartWidth;
    height = chartHeight;

    const g = ctx.createLinearGradient(0, bottom, 0, top);
    g.addColorStop(pos(0),  getGPAColor(0));
    g.addColorStop(pos(1),  getGPAColor(1));
    g.addColorStop(pos(2),  getGPAColor(2));
    g.addColorStop(pos(3),  getGPAColor(3));
    g.addColorStop(pos(4),  getGPAColor(4));
    gradient = g;
  }

  return gradient;
}
